/* 3-11 (Pedro): em cada combinação, 1 peça inteira, 2 o que a vende, 3 pormenor, 4 ambiente dessa
   combinação (ou um geral), 5 infográfico, 6 medidas, depois o vídeo e o resto da combinação; os
   looks vêm sempre depois destas. Com menos de 3 imagens do produto, o ambiente vem a seguir às que houver.
   O «de perto» conta como uma das 3. Os nomes dos ambientes são os mesmos que sections/main-product usa.
   A função de cada imagem pode vir marcada no metacampo custom.imagens_funcoes do produto (JSON):
   {"<id do média>":"inteira|vende|pormenor|ambiente|infografico|medidas|fim"}.
   A marca só ordena as imagens que já se veem: nunca mostra uma de outra combinação. */
window.pstOrdenarGaleria = function (lista) {
  var RE_AMB = /^(amb-|cena-|look-|l11-|pdp2-cena)|-(corredor|sala)-/i;
  var F = window.pstFuncoesImagens || {};
  var RANK = { inteira: 0, vende: 1, pormenor: 2 };
  function nomeFoto(li) {
    var im = li.querySelector('img');
    return im ? (im.getAttribute('src') || im.currentSrc || '').split('?')[0].split('/').pop() : '';
  }
  function funcao(li) {
    var m = /(\d+)$/.exec(li.id || '');
    return (m && F[m[1]]) || '';
  }
  function pos(li) { var r = RANK[funcao(li)]; return r === undefined ? 9 : r; }
  var vis = Array.prototype.filter.call(lista.children, function (li) { return li.tagName === 'LI' && li.getClientRects().length > 0; });
  var eVideo = function (li) { return !!li.querySelector('deferred-media, video, iframe'); };
  var fotos = vis.filter(function (li) { return !eVideo(li) && !li.querySelector('product-model') && !li.hasAttribute('data-pst-look') && !li.hasAttribute('data-pdp4-perto'); });
  var daCombinacao = function (li) { return /^\(/.test(li.getAttribute('data-media-alt') || ''); };
  var eAmb = function (li) { var f = funcao(li); return f ? f === 'ambiente' : RE_AMB.test(nomeFoto(li)); };
  var eCotada = function (li) { var f = funcao(li), im = li.querySelector('img'); return f ? (f === 'medidas' || f === 'medidas_norma') : (/cotada/i.test(nomeFoto(li)) || /^(medidas|dimensions)\b/i.test(im ? im.getAttribute('alt') || '' : '')); };
  var eFim = function (li) { return funcao(li) === 'fim'; };
  var eInfo = function (li) { return funcao(li) === 'infografico'; };
  var eProduto = function (li) { return !eAmb(li) && !eCotada(li) && !eFim(li) && !eInfo(li); };
  var combo = fotos.filter(daCombinacao);
  var artigos = (combo.length ? combo : fotos).filter(eProduto);
  var gerais = combo.length ? fotos.filter(function (li) { return !daCombinacao(li) && eProduto(li); }) : [];
  var candidatas = artigos.concat(gerais).map(function (li, i) { return { li: li, i: i }; })
    .sort(function (a, b) { return (pos(a.li) - pos(b.li)) || (a.i - b.i); }).map(function (x) { return x.li; });
  var abre = candidatas.filter(function (li) { return funcao(li) === 'inteira'; })[0];
  var primeira = abre || artigos.filter(function (li) { return li.classList.contains('is-active'); })[0] || candidatas[0];
  if (!primeira) return;
  // Marca «inteira» diferente da foto da variante: a ativa passa a ser essa, e o telemóvel começa nela
  // (ao inserir antes da 1.ª, o browser mantém a vista na que lá estava, por isso repõe-se depois).
  var trocou = abre && lista.firstElementChild !== abre && !abre.classList.contains('is-active');
  if (trocou) {
    Array.prototype.forEach.call(lista.querySelectorAll(':scope > .is-active'), function (x) { x.classList.remove('is-active'); });
    abre.classList.add('is-active');
  }
  var amb = combo.filter(eAmb)[0] || fotos.filter(function (li) { return eAmb(li) && !daCombinacao(li); })[0] || lista.querySelector(':scope > [data-pst-amb][data-pst-look]');
  var video = vis.filter(eVideo)[0];
  var perto = lista.querySelector(':scope > [data-pdp4-perto]');
  var quantas = perto ? 2 : 3;
  var ordem = [primeira];
  candidatas.forEach(function (li) { if (ordem.length < quantas && ordem.indexOf(li) < 0) ordem.push(li); });
  if (perto) ordem.push(perto);
  if (amb) ordem.push(amb);
  var info = combo.filter(eInfo)[0] || fotos.filter(eInfo)[0];
  if (info) ordem.push(info);
  var cotada = combo.filter(eCotada)[0] || fotos.filter(eCotada)[0];
  if (cotada) ordem.push(cotada);
  if (video) ordem.push(video);
  combo.forEach(function (li) { if (ordem.indexOf(li) < 0 && !eFim(li)) ordem.push(li); });
  if (!combo.length) candidatas.forEach(function (li) { if (ordem.indexOf(li) < 0) ordem.push(li); });
  combo.filter(eFim).forEach(function (li) { ordem.push(li); });
  var antes = null;
  ordem.forEach(function (li) {
    var alvo = antes ? antes.nextElementSibling : lista.firstElementChild;
    if (li !== alvo) lista.insertBefore(li, alvo);
    antes = li;
  });
  if (trocou) [0, 80, 250].forEach(function (ms) { setTimeout(function () { lista.scrollLeft = 0; }, ms); });
};
/* Peças sem escolhas: o resto deste ficheiro não corre e a ordem é a do Liquid; só se mexe se houver marcas. */
document.addEventListener('DOMContentLoaded', function () {
  var lista = document.querySelector('media-gallery .product__media-list');
  if (lista && window.pstFuncoesImagens && !document.querySelector('[data-pdp4-am-dados]')) window.pstOrdenarGaleria(lista);
});

// Pistacho v4 — o conjunto da cama (bed-combo) fecha as opções numa linha; o
// botão «Adicionar ao carrinho» fica fora, à vista. Não se mexe no snippet:
// os fieldsets passam para dentro de um <details> (os listeners de change do
// bed-combo estão no próprio <bed-combo>, por isso continuam a ouvir).
// O <summary> diz a escolha atual («Estrado Simples · Sem colchão») e muda com
// ela; sem estrado nem colchão escolhidos, fica o convite, que vem na língua da
// página pelo data-pdp4-cama do h1 (snippets/pdp4-titulo).
(function () {
  function convite() {
    var h = document.querySelector('.pdp4-h1[data-pdp4-cama]');
    return (h && h.getAttribute('data-pdp4-cama')) || 'Completar com estrado e colchão';
  }
  function resumo(el, s) {
    var nomes = [];
    var algum = false;
    el.querySelectorAll('.bed-combo__group').forEach(function (g) {
      var r = g.querySelector('input[type="radio"]:checked');
      if (!r) return;
      if (r.value) algum = true;
      var n = r.closest('.bed-combo__opt');
      n = n && n.querySelector('.bed-combo__opt-name');
      if (n) nomes.push(n.textContent.trim());
    });
    s.textContent = algum ? nomes.join(' · ') : convite();
  }
  function fechar() {
    document.querySelectorAll('bed-combo.bed-combo').forEach(function (el) {
      // o <details> pode já vir feito do bed-combo.liquid (fechado logo a seguir ao HTML, CLS)
      var d = el.querySelector(':scope > .pdp4-extra');
      if (d && d.hasAttribute('data-pdp4-ligado')) return;
      if (!d) {
        var grupos = el.querySelectorAll(':scope > .bed-combo__group');
        if (!grupos.length) return;
        d = document.createElement('details');
        d.className = 'pdp4-extra';
        d.append(document.createElement('summary'));
        el.insertBefore(d, grupos[0]);
        grupos.forEach(function (g) { d.append(g); });
      }
      d.setAttribute('data-pdp4-ligado', '');
      var s = d.querySelector(':scope > summary');
      resumo(el, s);
      el.addEventListener('change', function () { resumo(el, s); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fechar);
  else fechar();
})();

/* ---- as amostras, à moda da pdp-2 ------------------------------------------

   O dono quis de volta a escolha dos materiais da ficha antiga (pdp-2): o nome do
   eixo em maiúsculas pequenas, a amostra grande com o nome ao lado (e «Petproof»
   por baixo), as bolinhas redondas que crescem com o nome por cima, o ponto
   dourado nas petproof, a nota, e o «Ver de perto» em ecrã inteiro.

   É uma pele por cima do seletor nativo, não um seletor novo. Os rádios do tema
   continuam no DOM (escondidos só nos eixos de material) e cada bolinha carrega
   no rádio dela: a variante, o preço, as fotografias da combinação, o URL e o
   carrinho continuam a ser do tema. Os tamanhos (que o tema dá em lista) não se
   tocam.

   O tema reescreve o innerHTML do <variant-selects> a cada escolha (global.js,
   updateOptionValues). A pele vive dentro do <variant-radios> do seu eixo, para
   ficar na ordem das opções; quando o HTML é trocado, um MutationObserver volta
   a pô-la lá (os mesmos nós, antes de pintar) e relê o que está escolhido.

   Os dados vêm do snippet pdp4-amostras: option_swatches, petproof_values e
   combo_images estão escritos em PT; em /en e /es pede-se a peça em PT e casa-se
   pelo id da variante e pela posição, como o pdp-2.js (localizar). Sem amostra
   no metafield, vale a do próprio tema (a textura ou cor da etiqueta nativa).

   Onda 2 (F2.6): com custom.materiais_da_peca o snippet manda também
   D.biblioteca (os materiais desta peça, escritos pela app). A biblioteca só
   ACRESCENTA: por cima do option_swatches, da carta e das fotos do visor, cada
   material dela substitui apenas o valor que casa (valor da opção em PT + eixo,
   que é o eixo da maioria dos valores da opção: há um tecido «Sand» e uma pele
   «Sand»). O que ela não cobre («Toda Madeira», MATE/BRILHO, as cores dos
   candeeiros) fica exatamente como estava, e a carta continua a ser pedida.
   Se o bloco JSON vier estragado, tenta-se de novo sem a "biblioteca": a ficha
   nunca se desliga por causa dela. */
(function () {
  'use strict';
  var bruto = document.querySelector('[data-pdp4-am-dados]');
  if (!bruto || !document.querySelector('.pdp4-h1')) return;
  var D, T = {}, fotosVisor = {};
  try { D = JSON.parse(bruto.textContent); } catch (e) {
    // Um erro do Liquid dentro da "biblioteca" não pode desligar a ficha: sem ela, é a de hoje.
    try { D = JSON.parse(bruto.textContent.replace(/"biblioteca"\s*:[\s\S]*?,(\s*"fonte_pt"\s*:)/, '$1')); D.biblioteca = null; }
    catch (e2) { return; }
  }
  try { T = JSON.parse(document.querySelector('[data-pdp4-am-t]').textContent) || {}; } catch (e) { T = {}; }
  try { fotosVisor = JSON.parse(document.querySelector('[data-pdp2-visor-fotos]').textContent) || {}; } catch (e) { fotosVisor = {}; }

  var ops = D.opcoes || [];
  var nomes = ops.map(function (o) { return o.nome; });
  var swatches = D.swatches || {}, petproof = D.petproof || [], combos = (D.combos && D.combos.items) || [];
  var PT = null;   // { nomes: [...], val(i, v) -> valor em PT }

  function tem(o, k) { return !!o && Object.prototype.hasOwnProperty.call(o, k); }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function tr(k, v) {
    var s = T[k] || '';
    if (v) Object.keys(v).forEach(function (n) { s = s.split('{' + n + '}').join(v[n]); });
    return s;
  }
  function comoPT(i, v) { return PT ? PT.val(i, v) : v; }
  function nomePT(i) { return PT ? PT.nomes[i] : nomes[i]; }
  function eixoDe(nome) {
    var s = String(nome).toLowerCase();
    for (var i = 0; i < nomes.length; i++) if (nomes[i].toLowerCase() === s) return i;
    return -1;
  }

  // As texturas do PIM são macros de 1 600 px: pede-se ao CDN o tamanho que se
  // mostra (o mesmo que o pdp-2.js faz).
  function semLargura(u) { return String(u || '').replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, ''); }
  function emLargura(u, w) {
    if (!u) return u;
    u = semLargura(u);
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function larguraVisor() {
    var px = Math.max(window.innerWidth || 0, window.innerHeight || 0) * (window.devicePixelRatio || 1);
    var degraus = [1200, 1800, 2400, 3200, 4096];
    for (var i = 0; i < degraus.length; i++) if (px <= degraus[i]) return degraus[i];
    return 4096;
  }
  function fotoVisor(tex) {
    if (!tex || !window.matchMedia || !window.matchMedia('(min-width: 900px)').matches) return '';
    var chave = String(tex).split('?')[0].split('/').pop().replace(/\.[a-z0-9]+$/i, '');
    return fotosVisor[chave] || '';
  }

  /* -- as opções traduzidas: o par PT -> língua da página, variante a variante
     (o mesmo raciocínio do localizar do pdp-2.js). */
  function localizar(pt) {
    if (!pt || !pt.options || pt.options.length !== ops.length) return;
    var nomesPT = [], aLocal = [], aPT = [];
    ops.forEach(function (o, i) {
      var n = pt.options[i];
      nomesPT[i] = String((n && typeof n === 'object' ? n.name : n) || o.nome);
      aLocal[i] = {}; aPT[i] = {};
    });
    var porId = {};
    (pt.variants || []).forEach(function (v) { porId[String(v.id)] = v; });
    (D.variantes || []).forEach(function (v) {
      var q = porId[String(v.id)];
      if (!q || !q.options) return;
      ops.forEach(function (o, i) {
        var vp = q.options[i], vl = v.o[i];
        if (vp == null || vl == null) return;
        aLocal[i][String(vp)] = vl;
        aPT[i][vl] = String(vp);
      });
    });
    PT = {
      nomes: nomesPT,
      local: function (i, v) { return tem(aLocal[i], v) ? aLocal[i][v] : v; },
      val: function (i, v) { return tem(aPT[i], v) ? aPT[i][v] : v; }
    };
  }

  // As amostras, o petproof e as fotografias por combinação passam para os nomes
  // e valores da página. Também em PT: no SLIM e no HUG as fotografias dizem
  // «tecido» e a opção chama-se «Revestimento» — o eixo acha-se pelos valores.
  function acertarDados() {
    var nomesChave = nomes.map(function (n, i) { return nomePT(i).toLowerCase(); });
    function eixoPT(k) { return nomesChave.indexOf(String(k).toLowerCase()); }
    function eixoPorValor(v) {
      for (var i = 0; i < ops.length; i++) {
        if (ops[i].valores.some(function (x) { return comoPT(i, x) === v; })) return i;
      }
      return -1;
    }
    function local(i, v) { return PT ? PT.local(i, v) : v; }

    var sw = {};
    Object.keys(swatches).forEach(function (k) {
      var orig = swatches[k] || {};
      var i = eixoPT(k);
      if (i < 0) { var v0 = Object.keys(orig)[0]; i = v0 ? eixoPorValor(v0) : -1; }
      if (i < 0) return;
      var dest = sw[nomes[i]] || {};
      Object.keys(orig).forEach(function (v) { dest[local(i, v)] = orig[v]; });
      sw[nomes[i]] = dest;
    });
    swatches = sw;

    var pp = [];
    petproof.forEach(function (v) {
      if (pp.indexOf(v) < 0) pp.push(v);
      ops.forEach(function (o, i) { var l = local(i, v); if (pp.indexOf(l) < 0) pp.push(l); });
    });
    petproof = pp;

    combos = combos.map(function (it) {
      var novo = {};
      Object.keys(it.sel || {}).forEach(function (k) {
        var v = it.sel[k], i = eixoPT(k);
        if (i < 0) i = eixoPorValor(v);
        if (i < 0) { novo[k] = v; return; }
        novo[nomes[i]] = local(i, v);
      });
      return { url: it.url, sel: novo };
    });
  }

  /* -- o seletor nativo ---------------------------------------------------- */

  // O seletor desta ficha: o da coluna onde está o h1 da v4 (um quick-view
  // aberto na página tem outro). Lido de cada vez — o tema pode trocá-lo.
  function selects() {
    var h = document.querySelector('.pdp4-h1');
    var info = h && h.closest('.product__info-wrapper');
    return info ? info.querySelector('variant-selects') : null;
  }
  function radios(vs, i) {
    return vs ? vs.querySelectorAll('input[type="radio"][name="' + CSS.escape(nomes[i]) + '"]') : [];
  }
  function escolhido(vs, i) {
    if (!vs) return null;
    var r = vs.querySelector('input[type="radio"][name="' + CSS.escape(nomes[i]) + '"]:checked');
    if (r) return r.value;
    var s = vs.querySelector('select[name="options[' + CSS.escape(nomes[i]) + ']"]');
    return s ? s.value : null;
  }
  function selecao() {
    var vs = selects();
    return nomes.map(function (n, i) { return escolhido(vs, i); });
  }

  // A amostra que o tema já pôs na etiqueta: a textura (--swatch-background), a
  // cor, ou a fotografia da variante (o «Toda Madeira» da VETRA, que o picker
  // repinta com a madeira escolhida).
  function doTema(input) {
    var lab = input && document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
    if (!lab) return null;
    var bg = (lab.style.getPropertyValue('--swatch-background') || '').trim();
    var m = bg.match(/url\(\s*['"]?([^'")]+)['"]?\s*\)/);
    if (m) return { url: m[1] };
    if (bg && /^(#|rgb|hsl)/i.test(bg)) return { cor: bg };
    var img = lab.querySelector('img');
    if (img && img.getAttribute('src')) return { url: img.getAttribute('src'), foto: true };
    return null;
  }
  // main_… é a fotografia do fornecedor (os candeeiros têm-na como amostra), não
  // uma textura: vale como foto — inteira na amostra grande, e sem visor.
  function eFoto(u) { return /\/main_[^\/]*$/.test(String(u).split('?')[0]); }
  function amostra(i, v) {
    var u = (swatches[nomes[i]] || {})[v];
    var a = u ? { url: u } : null;
    if (!a) {
      var vs = selects(), alvo = null;
      Array.prototype.forEach.call(radios(vs, i), function (r) { if (r.value === v) alvo = r; });
      a = doTema(alvo);
    }
    if (a && a.url && eFoto(a.url)) a.foto = true;
    return a;
  }

  // Um eixo é de medidas quando os valores (em PT) trazem números e unidades —
  // a regra do pdp-2.js, mais o «QUEEN SIZE (1600X2000)» das camas: esses ficam
  // com o seletor do tema. O resto só se veste se o tema já o mostra com
  // amostras (as etiquetas color__swatch--image) ou se há option_swatches.
  function eixoDeMedida(i) {
    var vals = ops[i].valores.map(function (v) { return comoPT(i, v); });
    return vals.length > 0 && vals.every(function (v) { return /\d/.test(v); }) &&
      /cm|mm|Ø|m\b|"|\d\s*x\s*\d|size/i.test(vals.join(' '));
  }
  function eMaterial(i, vs) {
    if (eixoDeMedida(i)) return false;
    var rs = radios(vs, i);
    if (!rs.length) return false;
    var lab = document.querySelector('label[for="' + CSS.escape(rs[0].id) + '"]');
    if (tem(swatches, nomes[i])) return true;
    return !!(lab && lab.classList.contains('color__swatch--image'));
  }

  /* -- a pele de cada eixo -------------------------------------------------- */

  var peles = [];   // peles[i] = o nó do eixo i (fica guardado entre trocas de HTML)

  function construir(i, vs) {
    var o = ops[i];
    var temPP = o.valores.some(function (v) { return petproof.indexOf(v) >= 0; });
    // Sem nenhuma textura no eixo (só fotografias das peças) não há nada para ver de perto.
    var temTextura = o.valores.some(function (v) { var a = amostra(i, v); return !!(a && (a.cor || (a.url && !a.foto))); });
    var el = document.createElement('div');
    el.className = 'pdp4-am';
    el.setAttribute('data-pdp4-am', i);
    el.innerHTML =
      '<div class="pdp4-am__cab"><p class="pdp4-am__r">' + esc(o.nome) + '</p></div>' +
      '<div class="pdp4-am__topo">' +
        '<span class="pdp4-am__amostra" data-pdp4-am-grande></span>' +
        '<p class="pdp4-am__n"><span data-pdp4-am-nome>&nbsp;</span>' +
          '<span class="pdp4-am__pp" data-pdp4-am-pp hidden>' + esc(tr('pp_rotulo') || 'Para animais') + '</span></p>' +
      '</div>' +
      '<div class="pdp4-am__fila" role="group" aria-label="' + esc(o.nome) + '">' + o.valores.map(function (v) {
        var pp = petproof.indexOf(v) >= 0;
        return '<button type="button" class="pdp4-am__sw' + (pp ? ' pdp4-am__sw--pp' : '') + '"' +
          ' data-pdp4-sw data-valor="' + esc(v) + '" aria-pressed="false" aria-label="' + esc(v) + '"></button>';
      }).join('') + '</div>' +
      (temPP ? '<p class="pdp4-am__nota-pp"><i></i>' + esc(tr('petproof_nota')) + '</p>' : '') +
      (!temTextura ? '' : '<p class="pdp4-am__ver"><button type="button" data-pdp4-ver aria-label="' + esc(tr('ver_de_perto') + ': ' + o.nome) + '">' +
        esc(tr('ver_de_perto')) + '</button></p>');
    // O «Personalizar peça» já não vem para o cabeçalho da pele: ao lado das opções
    // lia-se como mais uma variação de tecido. Mora depois da 1.ª concertina (L30, pdp4t-info).

    el.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pdp4-sw]');
      if (b) { escolher(i, b.getAttribute('data-valor')); return; }
      if (e.target.closest('[data-pdp4-ver]')) abrirVisor(i);
    });
    return el;
  }

  function escolher(i, v) {
    var vs = selects(), alvo = null;
    Array.prototype.forEach.call(radios(vs, i), function (r) { if (r.value === v) alvo = r; });
    if (!alvo) return;
    if (!alvo.checked) alvo.click();   // o tema faz o resto (change -> variante, preço, fotografias, URL)
    pintar();
  }

  // Só se escreve o que mudou: o observador do tema e o do petproof vigiam o body.
  function por(el, prop, val) { if (el.style[prop] !== val) el.style[prop] = val; }
  function pintarSw(b, a) {
    por(b, 'backgroundImage', a && a.url ? 'url("' + emLargura(a.url, 160) + '")' : '');
    por(b, 'backgroundColor', a && a.cor ? a.cor : '');
    if (b.classList.contains('pdp4-am__sw--sem') !== !a) b.classList.toggle('pdp4-am__sw--sem', !a);
  }

  function semPrefixo(eixo, v) {
    var e = String(eixo || '').trim(), s = String(v);
    if (e && s.length > e.length + 1 && s.slice(0, e.length + 1).toLowerCase() === (e + ' ').toLowerCase()) {
      var resto = s.slice(e.length + 1);
      // «Madera de roble» com o eixo «Madera»: o resto («de roble») não se diz sozinho
      return /^(de|do|da|of)\s/i.test(resto) ? s : resto;
    }
    return s;
  }

  function pintar() {
    var vs = selects();
    peles.forEach(function (el, i) {
      if (!el) return;
      var v = escolhido(vs, i);
      el.querySelectorAll('[data-pdp4-sw]').forEach(function (b) {
        var val = b.getAttribute('data-valor');
        var on = val === v ? 'true' : 'false';
        if (b.getAttribute('aria-pressed') !== on) b.setAttribute('aria-pressed', on);
        pintarSw(b, amostra(i, val));
      });
      var nome = el.querySelector('[data-pdp4-am-nome]');
      // Pistacho (22-10): sem repetir o nome do eixo («Lacado» + «Sereno», não «Lacado Sereno»)
      var mostra = v != null ? semPrefixo(ops[i] && ops[i].nome, v) : v;
      if (nome && mostra != null && nome.textContent !== mostra) nome.textContent = mostra;
      var pp = el.querySelector('[data-pdp4-am-pp]');
      // 3-11 (Pedro): uma vez só; com o grupo «Para animais» à vista, o rótulo por baixo do nome repetia-o.
      if (pp) pp.hidden = petproof.indexOf(v) < 0 || !!el.querySelector('.pdp4-am__fam-t span');
      var g = el.querySelector('[data-pdp4-am-grande]');
      var a = v != null ? amostra(i, v) : null;
      if (g) {
        por(g, 'backgroundImage', a && a.url ? 'url("' + emLargura(a.url, 340) + '")' : '');
        por(g, 'backgroundColor', a && a.cor ? a.cor : '');
        if (g.classList.contains('pdp4-am__amostra--foto') !== !!(a && a.foto)) g.classList.toggle('pdp4-am__amostra--foto', !!(a && a.foto));
        if (g.hidden !== !a) g.hidden = !a;
      }
    });
  }

  // Põe (ou volta a pôr) cada pele no <variant-radios> do seu eixo e esconde a
  // escolha nativa desse eixo. Não escreve nada se já estiver tudo no sítio.
  function montar() {
    var vs = selects();
    if (!vs) return;
    ops.forEach(function (o, i) {
      var rs = radios(vs, i);
      if (!rs.length) return;
      var caixa = rs[0].closest('.product-form__input');
      var vr = caixa && caixa.parentNode;
      if (!vr) return;
      if (peles[i] === undefined) peles[i] = eMaterial(i, vs) ? construir(i, vs) : null;
      if (!peles[i]) return;
      if (peles[i].parentNode !== vr || peles[i].nextElementSibling !== caixa) vr.insertBefore(peles[i], caixa);
      if (!caixa.classList.contains('pdp4-am-nativo')) caixa.classList.add('pdp4-am-nativo');
    });
    pintar();
  }

  /* -- ver os materiais de perto (o visor da pdp-2) -------------------------- */

  var visor = null, visorEixo = 0, visorIdx = 0;

  // A peça feita nesse material: a fotografia da combinação (combo_images) com
  // o resto da escolha atual.
  function pecaEm(eixo, valor) {
    var alvo = selecao(); alvo[eixo] = valor;
    var achado = combos.filter(function (it) {
      return Object.keys(it.sel || {}).every(function (e) {
        var i = eixoDe(e);
        return i < 0 || alvo[i] === it.sel[e];
      });
    })[0];
    return achado ? achado.url : null;
  }

  // A identidade dos materiais vem da página das amostras (como na pdp-2), pelo
  // eixo: há um tecido «Sand» e uma pele «Sand».
  var amostras = null, amostrasPedidas = false;
  var EIXO_SECCAO = {
    'tecido': 'tecidos', 'revestimento': 'tecidos',
    'pele': 'peles', 'eco-pele': 'peles',
    'tampo': 'pedras',
    'madeira': 'madeiras', 'base': 'madeiras',
    'lacado': 'lacados', 'composição': 'lacados', 'composicao': 'lacados',
    'metal': 'metais', 'puxador': 'metais'
  };
  function carregarAmostras() {
    if (amostrasPedidas) return;
    if (!D.amostras || !window.fetch) { amostrasPedidas = true; amostras = { seccoes: {}, quantos: {}, solto: {} }; sobreporBiblioteca(); return; }
    amostrasPedidas = true;
    fetch(D.amostras).then(function (r) { return r.json(); }).then(function (j) {
      amostras = { seccoes: {}, quantos: {}, solto: {} };
      (j.secoes || []).forEach(function (sec) {
        var k = sec.k || '';
        amostras.seccoes[k] = amostras.seccoes[k] || {};
        (sec.grupos || []).forEach(function (g) {
          (g.m || []).forEach(function (m) {
            var reg = { grupo: g.grupo || '', ref: m.ref || '', nota: g.nota || '', pet: !!g.pet };
            amostras.seccoes[k][m.n] = reg;
            amostras.quantos[m.n] = (amostras.quantos[m.n] || 0) + 1;
            amostras.solto[m.n] = reg;
          });
        });
      });
      sobreporBiblioteca();
      if (visor && !visor.hidden) pintarVisor();
      agruparTodos();
    }).catch(function () { amostras = { seccoes: {}, quantos: {}, solto: {} }; sobreporBiblioteca(); });
  }

  // -- a biblioteca (onda 2): só acrescenta ao que já havia ------------------
  var SECCAO_DO_EIXO = { tecido: 'tecidos', pele: 'peles', madeira: 'madeiras', lacado: 'lacados', pedra: 'pedras', metal: 'metais' };
  var BIB = (Array.isArray(D.biblioteca) && D.biblioteca.length) ? D.biblioteca : null;
  function chaveFicheiro(u) { return String(u || '').split('?')[0].split('/').pop().replace(/\.[a-z0-9]+$/i, ''); }
  // Corre no arranque, já com os valores em PT e antes do acertarDados (que
  // passa tudo para a língua da página). Mexe só nos valores que a biblioteca
  // cobre, no eixo da maioria; o resto do option_swatches fica intacto.
  function daBiblioteca(lista) {
    ops.forEach(function (o, i) {
      var vals = o.valores.map(function (v) { return comoPT(i, v); });
      var conta = {};
      lista.forEach(function (m) { if (vals.indexOf(m.v) > -1) conta[m.e] = (conta[m.e] || 0) + 1; });
      var eixo = Object.keys(conta).sort(function (a, b) { return conta[b] - conta[a]; })[0];
      if (!eixo) return;
      var np = String(nomePT(i)).toLowerCase(), k = null;
      Object.keys(swatches).forEach(function (c) { if (!k && String(c).toLowerCase() === np) k = c; });
      Object.keys(swatches).forEach(function (c) {
        if (k) return;
        var vs = Object.keys(swatches[c] || {});
        if (vals.some(function (x) { return vs.indexOf(x) > -1; })) k = c;
      });
      if (!k) k = nomePT(i);
      lista.forEach(function (m) {
        if (m.e !== eixo || vals.indexOf(m.v) < 0) return;
        if (m.img) {
          var dest = swatches[k] = swatches[k] || {};
          var antes = dest[m.v], chAntes = antes ? chaveFicheiro(antes) : '', ch = chaveFicheiro(m.img);
          dest[m.v] = m.img;
          if (m.perto) fotosVisor[ch] = m.perto;
          else if (chAntes && fotosVisor[chAntes] && !fotosVisor[ch]) fotosVisor[ch] = fotosVisor[chAntes];
        }
        if (m.pet && petproof.indexOf(m.v) < 0) petproof.push(m.v);
      });
    });
  }
  // A identidade (família, nota, ref.) da carta, com os campos que a biblioteca
  // traz preenchidos por cima. Os que ela não traz ficam os da carta.
  function sobreporBiblioteca() {
    if (!BIB || !amostras || !amostras.seccoes) return;
    BIB.forEach(function (m) {
      var k = SECCAO_DO_EIXO[m.e];
      if (!k) return;
      var sec = amostras.seccoes[k] = amostras.seccoes[k] || {};
      var velho = sec[m.v], reg = velho ? { grupo: velho.grupo, ref: velho.ref, nota: velho.nota, pet: velho.pet } : { grupo: '', ref: '', nota: '', pet: false };
      if (m.grupo) { reg.grupo = m.grupo; reg.pet = !!m.famPet; }
      if (m.nota) reg.nota = m.nota;
      if (m.ref) reg.ref = m.ref;
      sec[m.v] = reg;
      if (!velho) amostras.quantos[m.v] = (amostras.quantos[m.v] || 0) + 1;
      if (!velho || amostras.solto[m.v] === velho) amostras.solto[m.v] = reg;
    });
  }

  /* -- as famílias (no ar para todos desde 21-10, OK da consultora) ------------
     As bolinhas continuam todas à vista, mas arrumadas por família de tecido
     (Trama fina, Veludo, Veludo resistente…), com o nome da família por cima.
     O petproof passa a ser o nome da família: sai a nota da bolinha dourada.
     Os nomes vêm da página das amostras (em PT); em /en e /es traduzem-se aqui. */
  var FAMILIAS = true;
  var LINGUA = String(document.documentElement.lang || 'pt').slice(0, 2).toLowerCase();
  var FAM_T = {
    en: { 'TRAMA GROSSA': 'Coarse weave', 'TRAMA FINA': 'Fine weave', 'TRAMA FECHADA': 'Tight weave', 'VELUDO': 'Velvet', 'VELUDO DENSO': 'Dense velvet', 'VELUDO RESISTENTE': 'Performance velvet' },
    es: { 'TRAMA GROSSA': 'Trama gruesa', 'TRAMA FINA': 'Trama fina', 'TRAMA FECHADA': 'Trama cerrada', 'VELUDO': 'Terciopelo', 'VELUDO DENSO': 'Terciopelo denso', 'VELUDO RESISTENTE': 'Terciopelo resistente' }
  };
  function nomeFamilia(g) { var t = FAM_T[LINGUA]; return (t && t[String(g).toUpperCase()]) || baixinho(g); }
  function familiaDe(i, val) {
    if (!amostras || !amostras.seccoes) return null;
    var k = EIXO_SECCAO[String(nomePT(i) || '').toLowerCase().trim()];
    return k ? (amostras.seccoes[k] || {})[comoPT(i, val)] || null : null;
  }
  function agrupar(i) {
    var el = peles[i];
    if (!el || el.getAttribute('data-pdp4-fam')) return;
    var fila = el.querySelector('.pdp4-am__fila');
    if (!fila) return;
    var ordem = [], grupos = {};
    Array.prototype.forEach.call(fila.querySelectorAll('[data-pdp4-sw]'), function (b) {
      var a = familiaDe(i, b.getAttribute('data-valor'));
      var g = a && a.grupo ? a.grupo : '';
      // Todas as famílias petproof (Aqua e, desde 27-10, os veludos) num só grupo: dois rótulos
      // «Petproof» seguidos liam-se como um erro. As famílias ficam no title do rótulo.
      var pet = !!(a && a.pet);
      var k = pet && g ? '\u0000pet' : g;
      if (!grupos[k]) { grupos[k] = { pet: pet, bs: [], fams: [] }; ordem.push(k); }
      if (pet && g && grupos[k].fams.indexOf(g) < 0) grupos[k].fams.push(g);
      grupos[k].bs.push(b);
    });
    if (ordem.length < 2 || ordem.indexOf('') >= 0) return;
    el.setAttribute('data-pdp4-fam', '1');
    var caixa = document.createElement('div');
    caixa.className = 'pdp4-am__fams';
    ordem.forEach(function (g) {
      var f = document.createElement('div');
      f.className = 'pdp4-am__fam';
      // O petproof diz mais ao cliente do que «veludo resistente»: fica só ele, a dourado.
      f.innerHTML = grupos[g].pet
        ? '<p class="pdp4-am__fam-t" title="' + esc(grupos[g].fams.map(nomeFamilia).join(' · ')) + '"><span>' + esc(tr('pp_rotulo') || 'Para animais') + '</span></p>'
        : '<p class="pdp4-am__fam-t">' + esc(nomeFamilia(g)) + '</p>';
      var fl = document.createElement('div');
      fl.className = 'pdp4-am__fila';
      fl.setAttribute('role', 'group');
      fl.setAttribute('aria-label', grupos[g].pet ? (tr('pp_rotulo') || 'Para animais') : nomeFamilia(g));
      grupos[g].bs.forEach(function (b) { b.classList.remove('pdp4-am__sw--pp'); fl.appendChild(b); });
      f.appendChild(fl);
      caixa.appendChild(f);
    });
    fila.parentNode.replaceChild(caixa, fila);
    var nota = el.querySelector('.pdp4-am__nota-pp');
    if (nota) nota.parentNode.removeChild(nota);
  }
  function agruparTodos() {
    if (!FAMILIAS) return;
    peles.forEach(function (el, i) { if (el) agrupar(i); });
  }
  // As madeiras vêm em maiúsculas de catálogo; baixam-se as palavras, ficam as siglas.
  function baixinho(t) {
    var x = String(t || '').trim().replace(/^\|\s*/, '').replace(/\s*\|\s*/g, ' · ');
    if (!x || x !== x.toUpperCase()) return x;
    var out = x.split(' ').map(function (w) {
      var letras = w.replace(/[^A-Za-zÀ-ÿ]/g, '').length;
      if (/\d/.test(w) || (letras >= 2 && letras <= 3)) return w;
      return w.toLowerCase();
    }).join(' ');
    return out.charAt(0).toUpperCase() + out.slice(1);
  }
  function identidade(i, val) {
    if (!amostras || !amostras.seccoes) return '';
    var v = comoPT(i, val);
    var k = EIXO_SECCAO[String(nomePT(i) || '').toLowerCase().trim()];
    var a = k ? (amostras.seccoes[k] || {})[v] : (amostras.quantos[v] === 1 ? amostras.solto[v] : null);
    if (!a) return '';
    var linhas = [];
    if (a.grupo) linhas.push('<p class="pdp4-visor__col">' + esc(a.grupo) + '</p>');
    if (a.nota) linhas.push('<p class="pdp4-visor__nota">' + esc(a.nota) + '</p>');
    else if (a.ref && !a.grupo) linhas.push('<p class="pdp4-visor__nota">' + esc(baixinho(a.ref)) + '</p>');
    if (a.ref && a.grupo) linhas.push('<p class="pdp4-visor__ref">ref. ' + esc(a.ref) + '</p>');
    return linhas.join('');
  }

  function pintarVisor() {
    if (!visor) return;
    var o = ops[visorEixo], vals = o.valores;
    visorIdx = (visorIdx % vals.length + vals.length) % vals.length;
    var val = vals[visorIdx];
    var a = amostra(visorEixo, val);
    var tex = a && a.url && !a.foto ? semLargura(a.url) : '';
    var foto = fotoVisor(tex);
    var peca = pecaEm(visorEixo, val);
    var pp = petproof.indexOf(val) >= 0;
    var fundo = foto || tex;
    var estilo = fundo ? 'background-image:url(' + esc(emLargura(fundo, foto ? Math.min(larguraVisor(), 2560) : larguraVisor())) + ')' :
      (a && a.cor ? 'background-color:' + esc(a.cor) : '');

    visor.innerHTML =
      '<div class="pdp4-visor__fundo' + (foto ? ' e-foto' : '') + '"' + (estilo ? ' style="' + estilo + '"' : '') + '></div>' +
      '<div class="pdp4-visor__barra">' +
        '<div class="pdp4-visor__id">' +
          '<p class="pdp4-visor__eixo">' + esc(o.nome) + '</p>' +
          '<p class="pdp4-visor__nome">' + esc(val) + '</p>' +
          identidade(visorEixo, val) +
          (pp ? '<p class="pdp4-visor__pp">' + esc(tr('visor_pp')) + '</p>' : '') +
          '<button type="button" class="pdp4-visor__btn" data-pdp4-escolher>' + esc(tr('escolher_v', { v: val })) + '</button>' +
        '</div>' +
        (peca ? '<img class="pdp4-visor__peca" src="' + esc(emLargura(peca, 800)) + '" alt="' + esc(tr('em', { t: D.titulo || '', v: val })) + '">' : '') +
      '</div>' +
      '<div class="pdp4-visor__fila">' + vals.map(function (v, k) {
        var t = amostra(visorEixo, v);
        var st = t && t.url ? ' style="background-image:url(' + esc(emLargura(t.url, 160)) + ')"' :
          (t && t.cor ? ' style="background-color:' + esc(t.cor) + '"' : '');
        return '<button type="button" class="pdp4-visor__am' + (k === visorIdx ? ' e-agora' : '') +
          '" data-pdp4-vam="' + k + '" aria-label="' + esc(v) + '"' + st + '></button>';
      }).join('') + '</div>' +
      '<button type="button" class="pdp4-visor__x" data-pdp4-fechar aria-label="' + esc(tr('fechar')) + '">' + esc(tr('fechar')) + '</button>' +
      '<button type="button" class="pdp4-visor__seta pdp4-visor__seta--ant" data-pdp4-vant aria-label="' + esc(tr('anterior')) + '">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="1.5"/></svg></button>' +
      '<button type="button" class="pdp4-visor__seta pdp4-visor__seta--seg" data-pdp4-vseg aria-label="' + esc(tr('seguinte')) + '">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.5"/></svg></button>';
  }

  var focoAntes = null;
  function abrirVisor(i) {
    if (!visor) {
      visor = document.createElement('div');
      visor.className = 'pdp4-visor';
      visor.setAttribute('role', 'dialog');
      visor.setAttribute('aria-modal', 'true');
      visor.hidden = true;
      document.body.appendChild(visor);
      visor.addEventListener('click', function (e) {
        if (e.target.closest('[data-pdp4-fechar]')) { fecharVisor(); return; }
        if (e.target.closest('[data-pdp4-vant]')) { visorIdx--; pintarVisor(); return; }
        if (e.target.closest('[data-pdp4-vseg]')) { visorIdx++; pintarVisor(); return; }
        var am = e.target.closest('[data-pdp4-vam]');
        if (am) { visorIdx = +am.getAttribute('data-pdp4-vam'); pintarVisor(); return; }
        if (e.target.closest('[data-pdp4-escolher]')) {
          var eixo = visorEixo, v = ops[eixo].valores[visorIdx];
          fecharVisor();
          escolher(eixo, v);
        }
      });
    }
    carregarAmostras();
    focoAntes = document.activeElement;
    visorEixo = i;
    visorIdx = Math.max(0, ops[i].valores.indexOf(escolhido(selects(), i)));
    visor.setAttribute('aria-label', ops[i].nome);
    visor.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    pintarVisor();
    var f = visor.querySelector('[data-pdp4-fechar]'); if (f) f.focus();
  }
  function fecharVisor() {
    if (!visor || visor.hidden) return;
    visor.hidden = true;
    visor.innerHTML = '';
    document.documentElement.style.overflow = '';
    if (focoAntes && focoAntes.focus && document.contains(focoAntes)) focoAntes.focus({ preventScroll: true });
  }
  document.addEventListener('keydown', function (e) {
    if (!visor || visor.hidden) return;
    if (e.key === 'Escape') fecharVisor();
    else if (e.key === 'ArrowLeft') { visorIdx--; pintarVisor(); }
    else if (e.key === 'ArrowRight') { visorIdx++; pintarVisor(); }
  });

  /* -- arranque --------------------------------------------------------------- */

  function vigiar() {
    var agendado = false;
    // Mudanças dentro da própria pele ou do visor não contam: senão pintar
    // acordava o observador, que voltava a pintar.
    function nossa(m) {
      var n = m.target.nodeType === 1 ? m.target : m.target.parentNode;
      return !!(n && n.closest && n.closest('.pdp4-am, .pdp4-visor'));
    }
    new MutationObserver(function (lista) {
      if (agendado || lista.every(nossa)) return;
      agendado = true;
      Promise.resolve().then(function () { agendado = false; montar(); });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'src'] });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects')) pintar();
    });
  }

  /* -- o vídeo fica sempre em 2.º ------------------------------------------------
     O tema esconde as fotografias das outras combinações; com a 1.ª variante o
     vídeo está em 2.º, mas noutra combinação as fotos escondidas eram as que
     estavam antes dele e o vídeo saltava para 1.º. Depois de cada troca, o vídeo
     passa para logo a seguir à primeira fotografia visível. */
  var RE_AMB = /^(amb-|cena-|look-|l11-|pdp2-cena)|-(corredor|sala)-/i;
  function nomeFoto(li) {
    var im = li.querySelector('img');
    return im ? (im.getAttribute('src') || im.currentSrc || '').split('?')[0].split('/').pop() : '';
  }
  /* 2-11 (Pedro): a versão de um look numa combinação é uma imagem da ficha como as outras: alt
     «PEÇA (Lacado X · Metal Y)» e ficheiro «<handle do look>--<combinação>.jpg». Quando se vê a
     versão, o look original sai da galeria e o selo dele passa para ela; sem versão, o look
     original fica depois das imagens da combinação. */
  function versoesDosLooks(lista) {
    var filhos = Array.prototype.filter.call(lista.children, function (li) { return li.tagName === 'LI'; });
    var campo = document.querySelector('product-form input[name="id"], form[action*="/cart/add"] input[name="id"]');
    var vid = campo && campo.value;
    var ligadosHa = !!lista.querySelector(':scope > [data-look-vars]');
    var quantos = 0;
    filhos.forEach(function (slide) {
      var handle = slide.getAttribute('data-look-handle');
      if (!handle) return;
      var pref = (handle + '--').toLowerCase();
      var versao = filhos.filter(function (li) {
        return !li.hasAttribute('data-pst-look') && li.getClientRects().length > 0 && nomeFoto(li).toLowerCase().indexOf(pref) === 0;
      })[0];
      var selo = slide.querySelector('.pst-selo--fixo');
      if (versao && selo && !versao.querySelector('.pst-selo--fixo')) {
        if (getComputedStyle(versao).position === 'static') versao.style.position = 'relative';
        versao.appendChild(selo.cloneNode(true));
      }
      var ligado = slide.getAttribute('data-look-vars');
      var fora = ligado && vid && ligado.indexOf(',' + vid + ',') < 0;
      if (versao || fora) { slide.style.setProperty('display', 'none', 'important'); return; }
      // no máximo 6 looks de cada vez, contados só entre os que servem a combinação
      if (quantos >= 6 && ligadosHa) { slide.style.setProperty('display', 'none', 'important'); return; }
      slide.style.removeProperty('display');
      quantos++;
    });
    // 3-11: em baixo fica só o look que serve a combinação e não coube na galeria; sem repetir nem mostrar outra cor.
    var figs = Array.prototype.slice.call(document.querySelectorAll('[data-look-baixo]'));
    if (!figs.length) return;
    figs.forEach(function (f) {
      var slide = lista.querySelector(':scope > [data-look-handle="' + f.getAttribute('data-look-baixo') + '"]');
      var ligado = slide && slide.getAttribute('data-look-vars');
      var fora = ligado && vid && ligado.indexOf(',' + vid + ',') < 0;
      var naGaleria = slide && slide.style.display !== 'none';
      f.style.display = (fora || naGaleria) ? 'none' : '';
    });
    var cx = figs[0].parentElement;
    var algum = figs.some(function (f) { return f.style.display !== 'none'; });
    cx.style.display = algum ? '' : 'none';
    var cab = cx.previousElementSibling;
    if (cab && cab.classList.contains('pdp4-looks__cab')) cab.style.display = algum ? '' : 'none';
  }
  /* 3-11: combinação sem foto. O tema mostrava todas as imagens de todas as combinações. Fica a foto
     de estúdio mais próxima, a que partilha a opção com mais valores (em regra o tecido), e as medidas;
     as imagens gerais e os looks seguem as regras de sempre. */
  var semFotoChave = '';
  function semFoto(lista) {
    if (!lista.hasAttribute('data-pst-sf-ok')) return;
    Array.prototype.forEach.call(lista.querySelectorAll('[data-pst-sf-mostra]'), function (li) {
      li.removeAttribute('data-pst-sf-mostra');
      if (!window.pstVarianteSemFoto) return;
      li.classList.remove('product__media-item--show');
    });
    if (!window.pstVarianteSemFoto) { lista.removeAttribute('data-pst-sem-foto'); semFotoChave = ''; return; }
    lista.setAttribute('data-pst-sem-foto', '');
    // ao esconder imagens o carrossel ficava noutra posição: cada combinação começa na 1.ª imagem
    var chave = (window.pstOpcoesVariante || []).join('|');
    if (chave !== semFotoChave) { semFotoChave = chave; lista.scrollLeft = 0; requestAnimationFrame(function () { lista.scrollLeft = 0; }); }
    var ops = (window.pstOpcoesVariante || []).map(function (o) { return String(o).toLowerCase(); });
    var pesos = window.pstOpcoesPesos || [];
    var partes = function (a) { return a.slice(1, -1).split(' \u00b7 '); };
    var nota = function (a) {
      return partes(a).reduce(function (t, x) { var i = ops.indexOf(x); return t + (i >= 0 ? (pesos[i] || 1) : 0); }, 0);
    };
    var lis = Array.prototype.filter.call(lista.children, function (li) {
      return li.tagName === 'LI' && !li.hasAttribute('data-pst-look') && !li.hasAttribute('data-look-handle') && /^\(/.test(li.getAttribute('data-media-alt') || '');
    });
    var eCot = function (li) { var im = li.querySelector('img'); return /cotada/i.test(nomeFoto(li)) || /^(medidas|dimensions)\b/i.test(im ? im.getAttribute('alt') || '' : ''); };
    var estudio = function (li) { return !RE_AMB.test(nomeFoto(li)) && !eCot(li); };
    var melhor = null, nm = -1;
    lis.forEach(function (li) {
      if (!estudio(li)) return;
      var n = nota(li.getAttribute('data-media-alt'));
      if (n > nm) { nm = n; melhor = li; }
    });
    var alvo = melhor ? melhor.getAttribute('data-media-alt') : '';
    var mostra = function (li) { li.setAttribute('data-pst-sf-mostra', ''); li.classList.add('product__media-item--show'); };
    if (melhor) mostra(melhor);
    var temCotada = false;
    lis.forEach(function (li) {
      // parte da combinação escolhida, por exemplo a cotada de um tamanho
      if (li !== melhor && window.pstAltCombina && partes(li.getAttribute('data-media-alt')).every(function (x) { return ops.indexOf(x) >= 0; })) { mostra(li); if (eCot(li)) temCotada = true; }
    });
    if (!temCotada) lis.forEach(function (li) { if (eCot(li) && li.getAttribute('data-media-alt') === alvo) mostra(li); });
  }
  function arrumarVideo(voltarAoInicio) {
    var lista = document.querySelector('media-gallery .product__media-list');
    if (!lista) return;
    semFoto(lista);
    versoesDosLooks(lista);
    window.pstOrdenarGaleria(lista);
    if (voltarAoInicio && lista.scrollLeft) lista.scrollLeft = 0;
  }

  /* -- L53 (reunião 04): o revestimento de perto, como uma das imagens da galeria --
     A Cátia: muitas marcas põem o revestimento inteiro em alta definição na grelha,
     para compensar não haver showroom. A foto é a do «Ver de perto» (fotosVisor,
     2560 px) do tecido escolhido — ou da pele, ou da madeira, por esta ordem — e muda
     com a escolha. Fica a 3.ª da galeria (depois do vídeo); tocar nela abre o visor.
     Sem foto de perto para a escolha atual, a imagem não aparece (nunca uma amostra
     pequena esticada). Piloto nas âncoras: STRATA, EDEN e ECHO. */
  var PERTO_PILOTO = /\/products\/(banco-strata|banco-eden|cama-echo|cama-echo-sommier)\/?$/;
  function fotoPerto() {
    var sel = selecao(), ordem = ['tecidos', 'peles', 'madeiras'];
    for (var s = 0; s < ordem.length; s++) {
      for (var i = 0; i < ops.length; i++) {
        if (EIXO_SECCAO[String(nomePT(i) || '').toLowerCase().trim()] !== ordem[s] || !sel[i]) continue;
        var a = amostra(i, sel[i]);
        if (!a || !a.url || a.foto) continue;
        var hd = fotosVisor[chaveFicheiro(a.url)];
        if (hd) return { url: String(hd).split('&width')[0], eixo: i, nome: nomes[i], valor: sel[i] };
      }
    }
    return null;
  }
  function pertoNaGaleria() {
    if (!PERTO_PILOTO.test(location.pathname.replace(/^\/(en|es)(?=\/)/, ''))) return;
    var lista = document.querySelector('.product__media-list');
    if (!lista) return;
    var f = fotoPerto(), li = lista.querySelector('[data-pdp4-perto]');
    if (!f) { if (li) li.remove(); return; }
    if (!li) {
      li = document.createElement('li');
      li.className = 'product__media-item product__media-item--square product__media-item--show product__media-item--variant-alt pdp4-perto';
      li.setAttribute('data-pdp4-perto', '');
      li.innerHTML = '<button type="button" class="pdp4-perto__btn"><img alt="" loading="lazy" fetchpriority="low" decoding="async" width="1600" height="900"><span class="pdp4-perto__selo"></span></button>';
    }
    // o lugar pode já vir reservado do main-product (CLS); o clique liga-se uma vez
    if (!li.hasAttribute('data-pdp4-ligado')) {
      li.setAttribute('data-pdp4-ligado', '');
      li.querySelector('button').addEventListener('click', function () {
        var b = document.querySelectorAll('[data-pdp4-ver]')[0];
        var alvo = Array.prototype.find.call(document.querySelectorAll('[data-pdp4-ver]'), function (x) { return (x.getAttribute('aria-label') || '').indexOf(li.dataset.nome || '') > -1; }) || b;
        if (alvo) alvo.click();
      });
    }
    var sep = f.url.indexOf('?') > -1 ? '&' : '?';
    var img = li.querySelector('img');
    if (img.getAttribute('data-base') !== f.url) {
      img.setAttribute('data-base', f.url);
      img.src = f.url + sep + 'width=1600';
      img.srcset = [800, 1200, 1600, 2400].map(function (w) { return f.url + sep + 'width=' + w + ' ' + w + 'w'; }).join(', ');
      img.sizes = '(min-width: 990px) 30vw, 92vw';
    }
    li.dataset.nome = f.nome;
    var rot = f.nome + ' ' + f.valor + ' · ' + (tr('de_perto') || 'de perto');
    img.alt = rot;
    li.querySelector('.pdp4-perto__selo').textContent = rot;
    // a 3.ª das que se veem (o tema esconde as fotografias das outras combinações)
    var vis = Array.prototype.filter.call(lista.children, function (x) { return x !== li && x.offsetParent !== null; });
    var antes = vis[1] || vis[vis.length - 1];
    if (antes && antes.nextElementSibling !== li) { lista.insertBefore(li, antes.nextElementSibling); arrumarVideo(false); }
  }

  // Auditoria ES (27-10): a grelha dos materiais (pdp4t-materiais) escreve os valores em PT,
  // que é como estão no option_swatches. Fora do PT passam para o nome da opção na língua da página.
  function traduzirGrelha() {
    if (!PT) return;
    document.querySelectorAll('[data-pdp4-pt]').forEach(function (el) {
      var pt = el.getAttribute('data-pdp4-pt'), loc = null, eixo = -1;
      for (var i = 0; i < ops.length && loc === null; i++) {
        var l = PT.local(i, pt);
        if (ops[i].valores.indexOf(l) >= 0) { loc = l; eixo = i; }
      }
      if (loc === null || loc === pt) return;
      var t = el.firstChild;
      if (t && t.nodeType === 3) t.nodeValue = semPrefixo(ops[eixo].nome, loc);
    });
  }
  function arrancar() {
    traduzirGrelha();
    if (BIB) { try { daBiblioteca(BIB); } catch (e) {} }
    try { acertarDados(); } catch (e) {}
    montar();
    arrumarVideo();
    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.closest || !e.target.closest('variant-selects')) return;
      [120, 700].forEach(function (ms) { setTimeout(function () { arrumarVideo(true); }, ms); });
      [1600, 3200].forEach(function (ms) { setTimeout(function () { arrumarVideo(false); }, ms); });
      [150, 800, 1700, 3300].forEach(function (ms) { setTimeout(function () { try { pertoNaGaleria(); } catch (e) {} }, ms); });
    });
    try { pertoNaGaleria(); } catch (e) {}
    setTimeout(function () { try { pertoNaGaleria(); } catch (e) {} }, 1200);
    vigiar();
    if (FAMILIAS) carregarAmostras();
  }
  function pronto(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  // Em PT arranca já; em /en e /es pede-se primeiro a peça em PT (até 3 s; sem
  // resposta, arranca com as chaves como estão — as amostras do tema valem na mesma).
  if (D.fonte_pt && ops.length && window.fetch) {
    var foi = false;
    var seguir = function () { if (foi) return; foi = true; pronto(arrancar); };
    var espera = setTimeout(seguir, 3000);
    fetch(D.fonte_pt, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (pt) { if (!foi) { try { localizar(pt); } catch (e) { PT = null; } } })
      .catch(function () {})
      .then(function () { clearTimeout(espera); seguir(); });
  } else {
    pronto(arrancar);
  }
})();

// Esqueleto da galeria (26-10): marca cada fotografia quando acaba de carregar; ao trocar de
// variante o tema muda o src/srcset ou acrescenta imagens, e a marca sai até a nova chegar.
// O CSS (custom-styles.css) mostra o brilho só nas que ainda não têm a marca.
(function () {
  var w = document.querySelector('.product__media-wrapper');
  if (!w) return;
  var sel = '.product__media img';
  function marca(im) {
    if (im.complete && im.naturalWidth) im.setAttribute('data-pst-ok', '');
    else im.removeAttribute('data-pst-ok');
  }
  w.addEventListener('load', function (e) {
    var t = e.target;
    if (t.tagName === 'IMG' && t.matches(sel)) t.setAttribute('data-pst-ok', '');
  }, true);
  w.querySelectorAll(sel).forEach(marca);
  new MutationObserver(function (ms) {
    ms.forEach(function (m) {
      if (m.type === 'attributes') { if (m.target.matches && m.target.matches(sel)) marca(m.target); return; }
      m.addedNodes.forEach(function (n) {
        if (!n.querySelectorAll) return;
        if (n.matches && n.matches(sel)) marca(n);
        n.querySelectorAll(sel).forEach(marca);
      });
    });
  }).observe(w, { subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset'] });
  document.documentElement.classList.add('pst-esq');
})();

// L31 (26-10): selo «Personalizável» na 2.ª imagem visível da galeria. A galeria mostra e esconde
// fotografias conforme a variante, por isso a «2.ª» volta a calcular-se quando as classes mudam.
// 26-10: o mesmo para o selo da peça âncora (data-pst-selo1), na 1.ª imagem visível.
// 2-11 (Pedro): o «Personalizável» deixou de ser automático; só nas imagens de snippets/selo-medida-lista.
[['[data-pst-selo1]', 'data-pst-selo1', 0, 'pst-selo pst-selo--ancora']].forEach(function (cfg) {
  var fonte = document.querySelector(cfg[0]);
  var w = document.querySelector('.product__media-wrapper');
  if (!fonte || !w) return;
  var texto = fonte.getAttribute(cfg[1]);
  var classe = cfg[3], sel = '.' + classe.split(' ').join('.');
  var pendente = false;
  function por() {
    pendente = false;
    var itens = Array.prototype.filter.call(w.querySelectorAll('.product__media-list > .product__media-item'), function (li) {
      // a imagem de perto (L53) não leva selos: é o tecido, não a peça
      return li.offsetWidth > 0 && li.offsetHeight > 0 && !li.hasAttribute('data-pdp4-perto') && !li.hasAttribute('data-pst-look');
    });
    var alvo = itens[cfg[2]];
    // 29-10 (Pedro): o «Personalizável» vai para as imagens geradas por IA (looks da galeria e
    // as media que o estudio marca em custom.media_ia), nunca para os renders de estúdio do NAS.
    // Sem a lista (peças ainda não marcadas), fica como estava: na 2.ª visível.
    var ia = cfg[1] === 'data-pst-selo' ? (fonte.getAttribute('data-pst-ia') || '').split(',').filter(Boolean) : [];
    if (ia.length) {
      var ancora = itens[0];
      var cand = Array.prototype.filter.call(w.querySelectorAll('.product__media-list > .product__media-item'), function (li) {
        if (!(li.offsetWidth > 0 && li.offsetHeight > 0) || li.hasAttribute('data-pdp4-perto')) return false;
        return li.hasAttribute('data-pst-look') || ia.indexOf(li.getAttribute('data-product-media-id') || '') >= 0;
      });
      cand = cand.filter(function (li) { return !li.querySelector('.pst-selo--fixo'); });
      alvo = cand.filter(function (li) { return li !== ancora; })[0] || cand[0] || null;
    }
    var atual = cfg[2] === 0 ? w.querySelector('.pst-selo--ancora') : w.querySelector('.pst-selo:not(.pst-selo--ancora):not(.pst-selo--fixo)');
    if (atual && alvo && alvo.contains(atual)) return;
    if (atual) atual.remove();
    if (!alvo) return;
    // No <li>, não na moldura da imagem: tocar na moldura desfazia o mix-blend da fotografia.
    if (getComputedStyle(alvo).position === 'static') alvo.style.position = 'relative';
    var el = document.createElement('span');
    el.className = classe;
    el.textContent = texto;
    el.style.cssText = 'position:absolute;top:12px;left:12px;right:auto;width:auto;z-index:10;';
    alvo.appendChild(el);
  }
  function agendar() { if (!pendente) { pendente = true; requestAnimationFrame(por); } }
  por();
  new MutationObserver(agendar).observe(w, { subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
  window.addEventListener('resize', agendar);
});

// 26-10: a linha «Perguntas frequentes» das concertinas leva ao fundo da ficha. O tema apanha os
// cliques nas ligações #… do bloco da compra; tratamos este antes dele (fase de captura).
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('.pdp4-c__ir');
  if (!a) return;
  var alvo = document.getElementById('perguntas');
  if (!alvo) return;
  e.preventDefault();
  e.stopPropagation();
  alvo.scrollIntoView({ behavior: 'smooth', block: 'start' });
}, true);

/* ---- L40 (reunião 03, piloto 27-10): infográfico discreto na 1.ª imagem do STRATA ----
   Pontos com uma legenda curta sobre a vista a 3/4 (as renders «…_cam_001», iguais em
   carvalho e nogueira), só com o que o levantamento das funcionalidades confirma (Excel
   «Produtos — trabalho por produto», 26-10): 2 gavetas com abertura por toque (e fecho suave,
   que fica para o alt), tabuleiro integrado, estofo com opção Petproof, base em madeira
   natural. A «madeira maciça» está por confirmar e não entra. Piloto: mede-se antes de
   alargar a outras peças. As posições são em % da imagem. */
(function () {
  var PECAS = {
    'banco-strata': {
      foto: /_cam_001/,
      pontos: [
        { x: 27, y: 40, lado: 'c', pt: 'Tabuleiro integrado', en: 'Built-in tray', es: 'Bandeja integrada' },
        { x: 68, y: 43, lado: 'c', pt: 'Almofada · opção para animais', en: 'Cushion · pet-friendly option', es: 'Cojín · opción antimanchas' },
        { x: 30, y: 56, lado: 'b', pt: '2 gavetas · abertura por toque', en: '2 drawers · push to open', es: '2 cajones · apertura al toque' },
        { x: 56, y: 67, lado: 'b', pt: 'Base em madeira natural', en: 'Natural wood base', es: 'Base de madera natural' }
      ]
    }
  };
  var h = location.pathname.replace(/^\/(en|es)(?=\/)/, '').replace(/^\/products\//, '').replace(/\/$/, '');
  var cfg = PECAS[h];
  var w = document.querySelector('.product__media-wrapper');
  if (!cfg || !w) return;
  var lg = (document.documentElement.lang || 'pt').slice(0, 2);
  if (lg !== 'en' && lg !== 'es') lg = 'pt';
  var pendente = false;
  function por() {
    pendente = false;
    var itens = Array.prototype.filter.call(w.querySelectorAll('.product__media-list > .product__media-item'), function (li) {
      return li.offsetWidth > 0 && !li.hasAttribute('data-pdp4-perto') && !li.hasAttribute('data-pst-look');
    });
    var alvo = itens[0];
    var atual = w.querySelector('.pdp4-info');
    var img = alvo && alvo.querySelector('img');
    var ok = img && cfg.foto.test(img.currentSrc || img.src || '');
    if (atual && (!ok || !alvo.contains(atual))) { atual.remove(); atual = null; }
    if (!ok || atual) return;
    if (getComputedStyle(alvo).position === 'static') alvo.style.position = 'relative';
    var cx = document.createElement('div');
    cx.className = 'pdp4-info';
    // o tema reposiciona os filhos do <li>: estilo no próprio elemento, como os selos
    cx.style.cssText = 'position:absolute;top:0;left:0;right:0;bottom:0;pointer-events:none;z-index:5;';
    cx.setAttribute('aria-hidden', 'true');
    cx.innerHTML = cfg.pontos.map(function (p) {
      return '<span class="pdp4-info__p pdp4-info__p--' + p.lado + '" style="position:absolute;left:' + p.x + '%;top:' + p.y + '%"><i></i><b>' + p[lg] + '</b></span>';
    }).join('');
    alvo.appendChild(cx);
    // para leitores de ecrã, as mesmas frases no alt da imagem
    if (img && img.alt.indexOf(cfg.pontos[0][lg]) < 0) img.alt = (img.alt ? img.alt + '. ' : '') + cfg.pontos.map(function (p) { return p[lg]; }).join('; ');
  }
  function agendar() { if (!pendente) { pendente = true; requestAnimationFrame(por); } }
  por();
  // o tema troca os <li> e as imagens ao mudar a variante: vigiar também elementos novos,
  // o srcset e o fim do carregamento de cada imagem
  new MutationObserver(agendar).observe(w, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'src', 'srcset'] });
  w.addEventListener('load', agendar, true);
  window.addEventListener('resize', agendar);
  document.addEventListener('change', function () { [300, 1200, 2500].forEach(function (ms) { setTimeout(agendar, ms); }); });
})();

/* ---- L121 (continua a L40): setas discretas no grande plano do ESCAPE 3 lugares ----
   Uma foto por combinação, sempre o mesmo enquadramento (por isso a lista de fotos e as posições
   em percentagem fixas). Só factos do Excel «Produtos — trabalho por produto», folha ESCAPE: almofadas
   soltas, base e pés em carvalho ou nogueira; do texto da ficha, tabuleiro em folheado. O tipo de madeira da base (maciça ou
   folheado) e se o tabuleiro é solto estão por confirmar e não entram. Máximo 3 setas por imagem. */
(function () {
  var PECAS = {
    'sofa-escape-3-lugares': {
      fotos: '70096824271196,70096824369500,70096824467804,70096824598876,70096824172892,70096824762716,70097512726876,70097512825180,70097512923484,70097513021788,70097513349468,70097513447772,72819992854876,72819992887644,72822435905884,72822435938652,72822435971420,72822436004188,72822436036956,72822436069724',
      setas: [
        { x: 46, y: 32, ly: 12, pt: 'Almofadas soltas', en: 'Loose cushions', es: 'Cojines sueltos' },
        { x: 78, y: 52, ly: 21, pt: 'Tabuleiro em folheado', en: 'Wood veneer tray', es: 'Bandeja en chapa' },
        { x: 30, y: 69, ly: 85, madeira: { pt: ['Base e pés em carvalho', 'Base e pés em nogueira'], en: ['Oak base and legs', 'Walnut base and legs'], es: ['Base y patas de roble', 'Base y patas de nogal'] } }
      ]
    }
  };
  var h = location.pathname.replace(/^\/(en|es)(?=\/)/, '').replace(/^\/products\//, '').replace(/\/$/, '');
  var cfg = PECAS[h];
  var lista = document.querySelector('.product__media-list');
  if (!cfg || !lista) return;
  var lg = (document.documentElement.lang || 'pt').slice(0, 2);
  if (lg !== 'en' && lg !== 'es') lg = 'pt';
  function pormenor() {
    Array.prototype.forEach.call(lista.querySelectorAll(':scope > .product__media-item[data-media-id]'), function (li) {
      var id = (li.getAttribute('data-media-id') || '').split('-').pop();
      if (cfg.fotos.indexOf(id) < 0 || li.querySelector(':scope > .pdp4-setas')) return;
      var nogueira = /nogueira|walnut|nogal/i.test(li.getAttribute('data-media-alt') || li.querySelector('[data-media-alt]') && li.querySelector('[data-media-alt]').getAttribute('data-media-alt') || '');
      var textos = cfg.setas.map(function (s) { return s.madeira ? s.madeira[lg][nogueira ? 1 : 0] : s[lg]; });
      if (getComputedStyle(li).position === 'static') li.style.position = 'relative';
      var cx = document.createElement('div');
      cx.className = 'pdp4-setas';
      // o tema reposiciona os filhos do <li>: estilo no próprio elemento, como os selos
      cx.style.cssText = 'position:absolute;top:0;left:0;right:0;bottom:0;pointer-events:none;z-index:5;';
      cx.setAttribute('aria-hidden', 'true');
      cx.innerHTML = cfg.setas.map(function (s, n) {
        var topo = Math.min(s.y, s.ly), alt = Math.abs(s.y - s.ly);
        return '<i class="pdp4-setas__l" style="position:absolute;left:' + s.x + '%;top:' + topo + '%;height:' + alt + '%"></i>' +
          '<i class="pdp4-setas__p" style="position:absolute;left:' + s.x + '%;top:' + s.y + '%"></i>' +
          '<b class="pdp4-setas__t pdp4-setas__t--' + (s.ly < s.y ? 'c' : 'b') + '" style="position:absolute;left:' + s.x + '%;top:' + s.ly + '%">' + textos[n] + '</b>';
      }).join('');
      li.appendChild(cx);
      var img = li.querySelector('img');
      if (img && img.alt.indexOf(textos[0]) < 0) img.alt = (img.alt ? img.alt + '. ' : '') + textos.join('; ');
    });
  }
  pormenor();
  new MutationObserver(pormenor).observe(lista, { childList: true });
  window.addEventListener('load', pormenor);
})();

// A fotografia que acompanha as opções (27-10, pedido do Pedro): no telemóvel, ao descer pelos
// tecidos, madeiras, tamanhos e lado, a galeria fica fora do ecrã e não se vê a peça a mudar.
// Uma miniatura fixa no canto de cima mostra a fotografia da escolha atual e troca a cada escolha;
// um toque volta à galeria. Fixa (não mexe no layout: CLS 0), só enquanto as opções estão à vista
// e a galeria não, e nunca no computador.
(function () {
  var lista = document.querySelector('.product__media-list');
  var opcoes = document.querySelector('variant-selects');
  if (!lista || !opcoes || !window.IntersectionObserver) return;
  var mq = window.matchMedia('(max-width: 749px)');
  var L = { pt: 'Ver a fotografia', en: 'See the photo', es: 'Ver la fotografía' }[(document.documentElement.lang || 'pt').slice(0, 2)] || 'Ver a fotografia';
  var mini = document.createElement('button');
  mini.type = 'button';
  mini.className = 'pdp4-segue';
  mini.setAttribute('aria-label', L);
  mini.innerHTML = '<img alt="" decoding="async">';
  document.body.appendChild(mini);
  var img = mini.querySelector('img');
  var galeriaFora = false, opcoesDentro = false, ultima = '';

  function atual() {
    var lis = Array.prototype.filter.call(lista.children, function (li) { return li.offsetParent !== null; });
    var li = lis.filter(function (x) { return x.classList.contains('is-active'); })[0] || lis[0];
    var im = li && li.querySelector('.product__media img, img');
    if (!im || li.querySelector('video, deferred-media, product-model')) im = lis.map(function (x) { return x.querySelector('.product__media img'); }).filter(Boolean)[0];
    return im ? (im.currentSrc || im.src || '') : '';
  }
  function pequena(u) {
    if (!u) return '';
    var base = u.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return base + (base.indexOf('?') > -1 ? '&' : '?') + 'width=240';
  }
  function trocar() {
    var u = pequena(atual());
    if (!u || u === ultima) return;
    ultima = u;
    mini.classList.add('pdp4-segue--troca');
    var nova = new Image();
    nova.onload = function () { img.src = u; requestAnimationFrame(function () { mini.classList.remove('pdp4-segue--troca'); }); };
    nova.onerror = function () { mini.classList.remove('pdp4-segue--troca'); };
    nova.src = u;
  }
  function mostrar() {
    var on = mq.matches && galeriaFora && opcoesDentro && !!ultima;
    if (on) {
      var h = document.querySelector('sticky-header, .header-wrapper, header');
      var topo = h ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
      mini.style.top = (topo + 10) + 'px';
    }
    if (mini.classList.contains('pdp4-segue--on') !== on) mini.classList.toggle('pdp4-segue--on', on);
  }
  new IntersectionObserver(function (es) { galeriaFora = !es[0].isIntersecting; mostrar(); }, { rootMargin: '-35% 0px 0px 0px' }).observe(lista);
  new IntersectionObserver(function (es) { opcoesDentro = es[0].isIntersecting; mostrar(); }).observe(opcoes);
  window.addEventListener('scroll', function () { if (mini.classList.contains('pdp4-segue--on')) mostrar(); }, { passive: true });

  var marcado = false;
  function agendar() { if (marcado) return; marcado = true; setTimeout(function () { marcado = false; trocar(); mostrar(); }, 120); }
  new MutationObserver(agendar).observe(lista, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'src', 'srcset'] });
  document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-selects, [data-pdp4-lado]')) [150, 600, 1500].forEach(function (ms) { setTimeout(agendar, ms); }); });
  trocar();

  mini.addEventListener('click', function () {
    var h = document.querySelector('sticky-header, .header-wrapper, header');
    var y = lista.getBoundingClientRect().top + window.pageYOffset - (h ? h.getBoundingClientRect().height : 0) - 8;
    window.scrollTo({ top: Math.max(0, y), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
})();

/* Klarna (28-10): só mostra a linha quando a Klarna dá prestações (tem números);
   a frase genérica «Pagamento seguro em segundos» fica escondida (pdp-v4.css).
   A Klarna volta a escrever a mensagem quando a variante muda, daí o observador. */
(function () {
  function ver(k) {
    var sh = k.shadowRoot, m = sh && sh.querySelector('[part~="osm-message"]');
    if (!m) return;
    if (!sh.__pstEst) { sh.__pstEst = 1; var e = document.createElement('style');
      // a caixa da Klarna tem recuos que não saem pelos ::part (pdp-v4.css)
      e.textContent = '.container,.text-wrapper{padding:0!important;margin:0!important;gap:0!important;min-height:0!important;border:0!important}.badge-container{display:none!important}';
      sh.appendChild(e); }
    var t = (m.textContent || '').replace(/\s+/g, ' ');
    k.setAttribute('data-pst-klarna', /\d/.test(t) ? 'sim' : 'nao');
  }
  function liga(k) {
    if (k.__pstK) return; k.__pstK = 1;
    var tenta = function () {
      if (!k.shadowRoot) return setTimeout(tenta, 300);
      ver(k);
      new MutationObserver(function () { ver(k); }).observe(k.shadowRoot, { childList: true, subtree: true, characterData: true });
    };
    tenta();
  }
  function todos() { document.querySelectorAll('klarna-placement').forEach(liga); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todos); else todos();
  setTimeout(todos, 1500);
})();

/* 3D só como botão no telemóvel (3-11, Pedro: «nao queremos 3d nos pcs... apenas o botao em
   mobile»). A galeria já não traz os modelos (sections/main-product); há um botão por modelo e
   mostra-se o da combinação escolhida. O alt dos 3D é «Vista 3D de CÚPULA, Ø 25 cm / Preto»,
   sem parênteses, e o fim é o título da variante. Um modelo cujo alt não nomeia nenhuma variante
   («Vista 3D de AUREO») serve para todas. O CSS (pdp-v4.css) só mostra .pst-xr-sim. */
(function () {
  var botoes = Array.prototype.slice.call(document.querySelectorAll('.product__xr-button[data-pst-xr-alt]'));
  if (!botoes.length) return;
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var h = location.pathname.split('/products/')[1];
  if (!h) return;
  h = h.split(/[/?#]/)[0];
  var titulos = null, titulosPt = {}, ultimo = null;
  function idAtual() {
    var i = document.querySelector('.product__info-wrapper form[action*="/cart/add"] input[name="id"]');
    return i ? String(i.value) : '';
  }
  function fimDoAlt(b) {
    var a = b.getAttribute('data-pst-xr-alt') || '', k = a.lastIndexOf(', ');
    return k < 0 ? '' : a.slice(k + 2).trim();
  }
  function aplica() {
    var id = idAtual();
    if (!titulos || !id || id === ultimo) return;
    ultimo = id;
    var t = (titulos[id] || '').toLowerCase(), tp = (titulosPt[id] || '').toLowerCase();
    var todos = Object.keys(titulos).map(function (k) { return titulos[k].toLowerCase(); })
      .concat(Object.keys(titulosPt).map(function (k) { return titulosPt[k].toLowerCase(); }));
    var dela = botoes.filter(function (b) { var f = fimDoAlt(b); return f && (f === t || f === tp); })[0];
    var geral = botoes.filter(function (b) { var f = fimDoAlt(b); return !f || todos.indexOf(f) < 0; })[0];
    var certo = dela || geral;
    botoes.forEach(function (b) { b.classList.toggle('pst-xr-sim', b === certo); });
  }
  var js = function (u) { return fetch(u).then(function (r) { return r.json(); }); };
  Promise.all([js(raiz + 'products/' + h + '.js'), raiz === '/' ? null : js('/products/' + h + '.js').catch(function () { return null; })]).then(function (r) {
    titulos = {};
    (r[0].variants || []).forEach(function (v) { titulos[String(v.id)] = v.title; });
    ((r[1] || r[0]).variants || []).forEach(function (v) { titulosPt[String(v.id)] = v.title; });
    aplica();
    setInterval(aplica, 400);
  }).catch(function () {});
})();

/* Vídeos das fichas (28-10): animação sem controlos (snippets/product-thumbnail). Com
   «reduzir movimento» ligado no sistema não tocam sozinhos: ficam no primeiro fotograma. */
(function () {
  if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.addEventListener('play', function (e) {
    var v = e.target;
    if (v && v.tagName === 'VIDEO' && v.closest('.product__media-list, .product-media-modal, .product__media-wrapper')) { v.pause(); try { v.currentTime = 0; } catch (x) {} }
  }, true);
})();

/* Vídeos das fichas no Safari (29-10): se o play falhar (iPhone em poupança de energia),
   o tema põe-lhes controls (global.js) e o Safari mostra a barra. Aqui nunca: tira o
   atributo sempre que aparece, e o vídeo fica parado no poster. */
(function () {
  function limpa(v) {
    if (v.hasAttribute('controls')) v.removeAttribute('controls');
    v.controls = false; v.muted = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    v.disablePictureInPicture = true; v.setAttribute('disablepictureinpicture', ''); v.setAttribute('disableremoteplayback', '');
  }
  function liga(raiz) {
    raiz.querySelectorAll('video').forEach(limpa);
    new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        if (m.type === 'attributes' && m.target.tagName === 'VIDEO' && m.target.hasAttribute('controls')) m.target.removeAttribute('controls');
        m.addedNodes && m.addedNodes.forEach(function (n) { if (n.tagName === 'VIDEO') limpa(n); else if (n.querySelectorAll) n.querySelectorAll('video').forEach(limpa); });
      });
    }).observe(raiz, { subtree: true, childList: true, attributes: true, attributeFilter: ['controls'] });
  }
  function arranca() { document.querySelectorAll('.product__media-list, .product-media-modal').forEach(liga); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arranca); else arranca();
})();


/* Até que imagem da galeria as pessoas chegam (3-11, para medir a ordem): uma imagem conta quando
   fica pelo menos 60 % à vista durante 0,6 s. Publica só quando se chega a uma posição nova, por
   isso nunca mais do que um evento por imagem. O píxel GA4 está em docs/loja/pixels. */
(function () {
  var lista = document.querySelector('media-gallery .product__media-list');
  if (!lista || !window.IntersectionObserver) return;
  var h = (location.pathname.split('/products/')[1] || '').split(/[/?#]/)[0];
  if (!h) return;
  var max = 0, timers = new Map();
  function visiveis() {
    return Array.prototype.filter.call(lista.children, function (li) { return li.tagName === 'LI' && li.getClientRects().length > 0; });
  }
  function tipo(li) {
    var m = /(\d+)$/.exec(li.id || ''), F = window.pstFuncoesImagens || {};
    if (m && F[m[1]]) return F[m[1]];
    if (li.hasAttribute('data-pst-look')) return 'look';
    if (li.hasAttribute('data-pdp4-perto')) return 'perto';
    if (li.querySelector('deferred-media, video, iframe')) return 'video';
    var im = li.querySelector('img');
    var n = im ? (im.getAttribute('src') || '').split('?')[0].split('/').pop() : '';
    if (/cotada/i.test(n)) return 'medidas';
    if (/^(amb-|cena-|l11-|pdp2-cena)|-(corredor|sala)-/i.test(n)) return 'ambiente';
    return 'produto';
  }
  function regista(li) {
    var v = visiveis(), p = v.indexOf(li) + 1;
    if (p <= max) return;
    max = p;
    window.pstGaleriaMax = p;
    var dados = { produto: h, posicao: p, total: v.length, tipo: tipo(li), ecra: window.innerWidth < 750 ? 'telemovel' : 'computador' };
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('galeria_imagem_vista', dados); } catch (e) {}
    try { if (window.clarity) clarity('set', 'galeria_max', String(p)); } catch (e) {}
  }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      clearTimeout(timers.get(e.target));
      if (e.isIntersecting && e.intersectionRatio >= 0.6) timers.set(e.target, setTimeout(function () { regista(e.target); }, 600));
    });
  }, { threshold: [0.6] });
  Array.prototype.forEach.call(lista.children, function (li) { if (li.tagName === 'LI') io.observe(li); });
})();
